import React from "react";
import "./SuccessPage.css";

const SuccessPage = () => {
  return (
    <div className="success-page container">
      <div className="success-details">
        <h1 className="success-title">Congratulations on Your Purchase!</h1>
        <p className="success-subtitle">
          You will get an email receipt shortly. (Be sure to check your junk folder)
        </p>
        <p className="success-message">
          Your courses and materials will be available in the Azure Innovation Station Community.
        </p>
        <a href="https://azureinnovationstation.com" className="community-link">
          Join the Azure Innovation Station Community
        </a>
        <p className="email-info">
          Frankie Riviera has your information and will be emailing updates on the status of the courses and content as they are published.
        </p>
        <p className="email-info">
          The goal is to have the 3 Core Azure AI courses published by December 1st or sooner!
        </p>
        <p className="email-info">
          If you have questions, please contact Frankie@frankieriviera.com, or message Frankie Riviera on Skool in the <a href="https://azureinnovationstation.com">
          Azure Innovation Station Community
        </a>.
        </p>
      </div>
    </div>
  );
};

export default SuccessPage;